export default "__VITE_ASSET__BNb2QWWC__"